export default __webpack_public_path__ + "static/media/Instagram.ed7c4bbb.svg";